import { useQuery } from "@apollo/client/react";

import { GithubIntegration, VcsProvider } from "types/generated";

import { GET_BUILT_IN_INTEGRATION } from "./gql";

const useGetDefaultIntegration = () => {
  const { data, loading } = useQuery<{
    providers: VcsProvider[];
    githubIntegration: GithubIntegration;
  }>(GET_BUILT_IN_INTEGRATION, {
    fetchPolicy: "cache-first",
  });

  return {
    loading,
    builtInGithubIntegration: data?.githubIntegration,
  };
};

export default useGetDefaultIntegration;
